export default [
  {
    name: 'Api Keys',
    path: '/api-keys',
    component: () => import('./pages/ApiKeys'),
    meta: {
      ability: [
        {
          resource: 'api_keys',
          actions: ['read'],
        },
      ],
    },
  },
]
